export enum FieldColumnType
{
    dimension="dimension",
    metric="metric"
}